/**
 * GA4 tracking conditionnel au consentement analytique.
 *
 * L'ID est lu dans REACT_APP_GA4_MEASUREMENT_ID (fallback: G-ZL4C3KL77Z).
 * Le script `gtag` est chargé UNIQUEMENT si l'utilisateur a coché "Analytique"
 * dans la bannière cookies. Un dispatch d'événement `bodyup:consent-changed`
 * charge/décharge dynamiquement le tracker.
 *
 * Événements custom recommandés (à appeler via `trackEvent`) :
 *   - lead_qualification_start   : le prospect ouvre le formulaire
 *   - lead_qualification_submit  : soumission complète
 *   - lead_qualified             : score >= 60 (redirection Calendly)
 *   - lead_not_qualified         : score < 60
 *   - payment_modal_open         : ouverture PaymentModal
 *   - calendly_click             : clic direct sur un bouton Calendly
 */

const GA_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-ZL4C3KL77Z';

let loaded = false;

function loadGtag() {
  if (loaded || typeof document === 'undefined') return;
  if (!GA_ID || !GA_ID.startsWith('G-')) return;

  // Injecte le script gtag.js
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.dataset.bodyupAnalytics = 'true';
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // gtag doit rester en fonction classique pour utiliser `arguments`.
  window.gtag = function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID, {
    anonymize_ip: true,
    send_page_view: true,
  });

  loaded = true;
}

function unloadGtag() {
  if (!loaded) return;
  // Retire les scripts injectés (best-effort, cookies purgés par ConsentContext)
  document.querySelectorAll('script[data-bodyup-analytics="true"]').forEach((s) => s.remove());
  delete window.gtag;
  delete window.dataLayer;
  loaded = false;
}

/** Initialise le listener consent + charge GA4 si déjà autorisé au bootstrap. */
export function initAnalytics() {
  if (typeof window === 'undefined') return;

  const applyConsent = (consent) => {
    if (consent && consent.analytics) loadGtag();
    else unloadGtag();
  };

  // Bootstrap
  try {
    const raw = localStorage.getItem('bodyup_consent_v1');
    if (raw) {
      const parsed = JSON.parse(raw);
      applyConsent(parsed);
    }
  } catch (e) { /* silent */ }

  window.addEventListener('bodyup:consent-changed', (ev) => applyConsent(ev.detail));
}

/** Log un événement GA4 (no-op si GA4 pas chargé). */
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', name, params);
}

/** Log une pageview manuelle (utile pour SPAs). */
export function trackPageview(path) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', { page_path: path });
}
